import { Button } from "@/components/ui/button";
import { NavLink } from "@/components/NavLink";
import { ArrowRight } from "lucide-react";

interface MidPageCTAProps {
  headline?: string;
  subheadline?: string;
}

export const MidPageCTA = ({ 
  headline = "See How Our Website Subscription Works",
  subheadline = "$200–$300/month, $0 upfront. Done-for-you websites that convert."
}: MidPageCTAProps) => {
  return (
    <section className="py-12 bg-accent/30">
      <div className="container px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center space-y-4">
          <h3 className="text-2xl md:text-3xl font-bold">{headline}</h3>
          <p className="text-muted-foreground">{subheadline}</p>
          <NavLink to="/websites/">
            <Button size="lg" className="gap-2">
              See Website Subscription Pricing
              <ArrowRight className="h-4 w-4" />
            </Button>
          </NavLink>
        </div>
      </div>
    </section>
  );
};
